import useDictStore from '@/store/modules/dict'

export default {
  data: {
    YESORNOT: [{
      label: "是",
      value: 1
    }, {
      label: "否",
      value: 0
    }],
    TRANSPARENT: [{
      label: "是",
      value: true
    }, {
      label: "否",
      value: false
    }],
    BIGTYPESTATUS: [{
      label: "禁用",
      value: "0"
    }, {
      label: "启用",
      value: "1"
    }],
    DOCUMENTTYPE: [{
      label: "开发文档",
      value: "1"
    }],
    //产品角色
    DEVICEROLENAME: [{
      label: "普通设备",
      value: 1
    }, {
      label: "子设备",
      value: 2
    }, {
      label: "网关设备",
      value: 3
    }, {
      label: "附件设备",
      value: 4
    }],
    //接入方案
    ACCESSPLAN: [{
      label: "直接接入",
      value: 1
    }],
    //开发方式
    DEVELOPWAY: [{
      label: "模组接入",
      value: 1
    }],
    YESORNO: [{
      label: "是",
      value: 1
    }, {
      label: "否",
      value: 0
    }],
    // 读写类型：readable + writable -> 只读/只写/读写
    // 注：只写(write)目前业务未用到，暂时不出现在选项中；如需开启请取消注释 write 项
    READWRITE_TYPE: [{
      label: "只读",
      value: "read",
      tip: "app及后台只读取主板数据用作显示或者其他处理，不下发相关键值和显示在app"
    },
    // {
    //   label: "只写",
    //   value: "write"
    // },
    {
      label: "读写",
      value: "readWrite",
      tip: "既要要发送控制又要收取对应状态处理"
    }],
    //接入方式
    ACCESSTYPE: [{
      label: "WIFI模块",
      value: 1
    }, {
      label: "蓝牙模块",
      value: 2
    }, {
      label: "WIFI+蓝牙模块",
      value: 3
    }, {
      label: "4G模块",
      value: 4
    }],
    //通讯方式
    COMMUNICATIONTYPE: [{
      label: "WIFI",
      value: 1
    }, {
      label: "BLE",
      value: 2
    }, {
      label: "BLE广播",
      value: 3
    }, {
      label: "Zigbee",
      value: 4
    }, {
      label: "网线",
      value: 5
    }],
    //支持、不支持
    ISSUPPORT: [{
      label: "支持",
      value: true
    }, {
      label: "不支持",
      value: false
    }],
    //是否支持音视频
    ISSUPPORTMEDIA: [{
      label: "支持音视频",
      value: 1
    }, {
      label: "仅支持音频",
      value: 2
    }, {
      label: "不支持",
      value: 3
    }],
    //设备状态
    USESTATUS: [{
      label: "未激活",
      value: 0
    }, {
      label: "型号错误",
      value: 1
    }, {
      label: "正常",
      value: 2
    }],
    //是否带屏
    ISSCREEN: [{
      label: "是",
      value: 1
    }, {
      label: "否",
      value: 2
    }],
    //控制通路配置
    CONTROLCHANNEL: [{
      label: "WIFI小循环通路",
      value: '1'
    }, {
      label: "WIFI大循环通路",
      value: '2'
    }, {
      label: "BEL通路",
      value: '3'
    }],
    //绑定方式
    BINDTYPE: [{
      label: "允许二次绑定",
      value: 1
    }, {
      label: "禁止二次绑定",
      value: 2
    }],
    //固件升级
    ISSUPPORTUPGRADE: [{
      label: "支持",
      value: 1
    }, {
      label: "不支持",
      value: 2
    }],
    //设备状态
    DEVICESTATUS: [{
      label: "离线",
      value: 0
    }, {
      label: "在线",
      value: 1
    }],
    //日志类型
    LOGTYPE: [{
      label: "绑定日志",
      value: 1
    },
    {
      label: "设备本地日志",
      value: 2
    }],
    //所属功能集类型
    PRODUCTTYPE: [{
      label: "TypeID",
      value: 1
    }],
    //子固件类型
    FIRMWARESUBTYPE: [{
      label: "设备电脑板",
      value: 1
    }, {
      label: "WIFI模组",
      value: 2
    }, {
      label: "自定义",
      value: 3
    }],
    // 设备是否为电池供电
    POWERBATTERY: [{
      label: "否",
      value: 0
    }, {
      label: "是",
      value: 1
    }],
    // 任务类型
    TASKTYPE: [{
      label: "正式任务",
      value: 1
    }, {
      label: "测试任务",
      value: 2
    }],
    //升级交互方式
    INTERACTIONMODE: [{
      label: "用户确认升级",
      value: 1
    }, {
        label: "系统默认升级",
        value: 2
    }],
    //升级方式
    UPGRADEMETHOD: [{
      label: "WIFI升级",
      value: 1
    }, {
      label: "蓝牙升级",
      value: 2
    }],
    //升级结果
    UPDATERESULT: [{
      label: "失败",
      value: 1
    }, {
      label: "成功",
      value: 2
    }, {
      label: "升级中",
      value: 3
    }],
    //升级范围
    SCOPETYPE: [{
      label: "仅升级适用版本",
      value: 1
    }, {
      label: "仅升级适用设备",
      value: 2
    }, 
    // {
    //   label: "仅升级适用模组ID",
    //   value: 3
    // }
  ],
    //升级区域
    AREATYPE: [{
      label: "全国",
      value: 1
    }, {
      label: "部分省市区域",
      value: 2
    }],
    //升级策略
    STRATEGY: [{
      label: "升级中下载固件",
      value: 1
    }],
    //任务状态
    TASKSTATUS: [{
      label: "验证中",
      value: 1
    }, {
      label: "验证完成",
      value: 2
    }, {
      label: "待发布",
      value: 3
    }, {
      label: "发布成功",
      value: 4
    }, {
      label: "暂停",
      value: 5
    },{
      label: "完成",
      value: 6
    },],
    // 操作来源
    ORIGIN_TYPE: [{
      label: "功能集",
      value: 1
    }, {
      label: "产品型号",
      value: 2
    }],
  },
  getList(key) {
    let list = useDictStore().getDict(key)
    return list
  },
  getLabel(_key, _value) {
    const dict = this.getList(_key)
    if (!dict) return ''
    for (let data of dict) {
      const value = data.value
      if (value == _value) {
        return data.label || data.name
      }
    }
  },
  getValue(_key,_name){
    const dict = this.getList(_key)
    if (!dict) return ''
    for (let data of dict) {
      const name = data.name
      if (name == _name) {
        return data.value
      }
    }
  }
}

